import { createRoute } from "@tanstack/solid-router";
import { listRoute } from "./lists.$listId";

export const listTodoRoute = createRoute({
  getParentRoute: () => listRoute,
  path: "/todo/$todoId",
  component: TodoDetailRoutePage,
});

function TodoDetailRoutePage() {
  return null;
}
